module["exports"] = [
  "вул.",
  "вулиця",
  "пр.",
  "проспект",
  "пл.",
  "площа",
  "пров.",
  "провулок"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/uk/address/street_prefix.js
// module id = 983
// module chunks = 0